var scope_0 = require('/Users/silvenon/Code/pubmet/workspaces/2019/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/180c104e267916925f690634ad755c49.js').default;
var scope_1 = require('/Users/silvenon/Code/pubmet/workspaces/2019/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    